import styled from "styled-components";

export const HighlightActiveQuestion = styled.span`
	width: 5px;

	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;

	background: #96c8a0;
	border-radius: 8px 0px 0px 8px;
`;

export const QuestionPanel = styled.div`
	position: relative;

	margin-bottom: 20px;

	background: #ffffff;

	border: 1px solid #e8e8e8;
	box-sizing: border-box;
	border-radius: 8px;

	overflow: hidden;

	:last-of-type {
		margin: 0;

		border: 1px dashed #d1d1d1;
	}
`;

export const QuestionMain = styled.div`
	padding: 0 20px 20px;

	textarea {
		border: 1px solid #d9d9d9;
		box-sizing: border-box;
		border-radius: 4px;
	}
`;

export const QuestionHeader = styled.div`
	padding: 20px;
	display: flex;
	/* flex-wrap: wrap; */
	align-items: center;
`;

export const QuestionFooter = styled.div`
	padding: 20px;
	display: flex;
	flex-direction: row-reverse;
	align-items: center;
	justify-content: space-between;

	border-top: 1px solid #e8e8e8;

	color: #747474;
	font-size: 18px;

	button {
		border: none;

		cursor: pointer;

		* {
			pointer-events: none;
		}

		&:not(.ant-switch) {
			background-color: transparent;
		}

		&:nth-of-type(1) {
			font-style: normal;
			font-weight: normal;
			font-size: 14px;
			line-height: 22px;

			color: #fec708;

			i:not(.anticon-delete) {
				margin-right: 8px;
			}
		}
	}
	i {
		cursor: pointer;
	}
`;

export const QuestionInput = styled.div`
	padding: 0;

	margin-right: 32px;

	flex: 1 0 330px;
	display: flex;
	align-items: center;
`;

export const NPSOptions = styled.div`
	display: flex;

	.scale-title {
		width: 100%;

		display: flex;
		justify-content: space-between;
		align-items: center;

		span {
			color: #747474;
			margin-bottom: 7px;
			font-weight: 500;
			font-size: 12px;
			line-height: 18px;
		}
	}

	label:nth-of-type(n) {
		width: 43px;
		margin: 0;

		display: flex;
		align-items: center;
		justify-content: center;

		font-style: normal;
		font-weight: bold;
		font-size: 16px;
		line-height: 24px;

		border: 0;

		color: #ffffff;
		background: #d62725;
	}

	label:nth-last-of-type(-n + 4) {
		background: #fdc619;
	}

	label:nth-last-of-type(-n + 2) {
		background: #00a46e;
	}
`;

export const RadioOptions = styled.div`
	/* display: flex;
	align-items: center; */
`;

export const RadioOption = styled.div`
	display: flex;
	align-items: center;

	margin-bottom: 20px;

	button {
		border: none;
		margin-left: 15px;

		color: #d5d5d5;
		background: transparent;

		cursor: pointer;

		* {
			pointer-events: none;
		}
	}

	&:last-of-type {
		margin-bottom: 0;
	}

	&:first-child {
		cursor: not-allowed;
	}
`;

export const AddQuestionBtn = styled.div`
	padding: 20px;
	text-align: center;
	color: #464646;

	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 22px;

	cursor: pointer;

	* {
		margin: 0 4px;
	}
`;
